export default "__VITE_ASSET__70d63637__"